import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-ops-table-body',
    templateUrl: './ops-table-body.component.html',
    styleUrls: ['./ops-table-body.component.scss'],
    standalone: false
})
export class OpsTableBodyComponent {
    @Input() isLoading: boolean = false;
    @Input() loadingTemplateRows = 3;
}
